import type { Profile } from 'shared/hooks/use-load-profile';

type PosthogIdentityInput = {
  profile: Profile;
  tenant: string;
};

export const buildPosthogIdentity = ({ profile, tenant }: PosthogIdentityInput) => {
  const activeTenant = profile.accessibleTenants.find(({ subdomain }) => subdomain === tenant);

  return {
    distinctId: profile.id.toString(),
    personProperties: {
      tenant,
      accessibleTenants: profile.accessibleTenants,
      locale: profile.locale,
      isAdmin: profile.isAdmin,
      roles: profile.roles,
    },
    group: {
      type: 'company' as const,
      key: tenant,
      properties: activeTenant ? { name: activeTenant.companyName } : undefined,
    },
  };
};
